// extracted by mini-css-extract-plugin
module.exports = {"insMask":"InsCardComponent--insMask--iqma83f","insCardWrapper":"InsCardComponent--insCardWrapper--SI9_rPF"};